import { DynamicStandaloneContentLock } from '@/components/ContentLock';
import { LabradorComponent } from '@/types/component';
import { parseAccessLevel } from '@/utils/parseAccessLevel';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorContentLock: LabradorComponent = ({ type, meta }) => {
  const accessLevel = parseAccessLevel(meta?.accessLevel);

  return <DynamicStandaloneContentLock {...{ accessLevel }} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorContentLock;
